// extracted by mini-css-extract-plugin
export default {"poolsPage":"Pools_poolsPage__qBuhB","content":"Pools_content__SeVIv"};